import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { DEFAULT_LANG } from '../../helpers/languageHelpers';

type Path = {
  pathname?: string;
};

export const useNavigateWithLang = () => {
  const { locale } = useIntl();
  const history = useHistory();

  const navigateWithLang = useCallback(
    (to: string | number | Partial<Path>, delay?: number) => {
      if (typeof to === 'number') {
        history.go(to as number);
        return;
      }
      if (typeof to !== 'string') {
        if (to?.pathname) {
          to.pathname = locale !== DEFAULT_LANG ? `/${locale}${to.pathname}` : to.pathname;
        }
        if (delay) {
          setTimeout(() => {
            history.push(to as Partial<Path>);
          }, delay);
        } else {
          history.push(to as Partial<Path>);
        }
        return;
      }

      let route: string = to as string;
      if (locale && locale !== DEFAULT_LANG) {
        route = `/${locale}${route}`;
      }
      history.push(route);
    },
    [history, locale]
  );

  return navigateWithLang;
};
